import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { QuestionAnswerCategoryProvider } from './context/question-answer-category-context';
import { QuestionAnswerCategoryComponent } from './question-answer-category-component';

export function QuestionAnswerCategoryFactory() {
    return (
        <BaseLayoutFactory>
            <QuestionAnswerCategoryProvider>
                <QuestionAnswerCategoryComponent />
            </QuestionAnswerCategoryProvider>
        </BaseLayoutFactory>
    );
}
